import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.688 17.012c.313.312.737.488 1.179.488H14.2a1.667 1.667 0 0 0 1.667-1.667V7.845a.83.83 0 0 0-.244-.59l-4.512-4.51a.83.83 0 0 0-.59-.245H5.868A1.667 1.667 0 0 0 4.2 4.167v11.666c0 .442.176.866.488 1.179m8.596-7.845a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0zm-2.5 1.666a.75.75 0 0 0-1.5 0v3.334a.75.75 0 0 0 1.5 0zm-2.5 1.667a.75.75 0 1 0-1.5 0v1.667a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }